module.exports = __webpack_public_path__ + "img/video-preview-xs-2x.61d2567.jpg";